import { OrderCheck } from "@interfaces/course/course-detail"
import { Result } from "@lib/api/services/result"
import { CourseDetail, Review } from "@interfaces/course/course-detail"
import { PaginationData } from "@interfaces/misc"
import CourseDetailRepositories from "@repositories/course-detail.repositories"

interface LinkResponse {
  status: string
  link: {
    id: number
    title: string
    hash: string
    alias: string
    long_url: string
    short_url: string
    disabled: false
    expires_at: Date
    description: string
    type: string
    clicks_count: number
    expiration_clicks: number
    utm: string
    has_password: boolean
  }
}

export default class CourseDetailServices extends CourseDetailRepositories {
  async getCourseDetail(courseId: string) {
    try {
      const res = await this.getRawCourseDetail(courseId)
      const response = await this._getResponse<CourseDetail>(res)

      if (response.error) {
        return Result.fail<CourseDetail>()
      }

      return Result.ok<CourseDetail>(response.result)
    } catch (e) {
      return Result.fail<CourseDetail>()
    }
  }

  async getReviews(courseId: string, page = 1) {
    try {
      const res = await this.getRawReview(courseId, { page })
      const response = await this._getResponse<PaginationData<Review>>(res)

      if (response.error) {
        return Result.fail<PaginationData<Review>>()
      }

      return Result.ok<PaginationData<Review>>(response.result)
    } catch (e) {
      return Result.fail<PaginationData<Review>>()
    }
  }

  async checkOrder(courseId: string) {
    try {
      const res = await this.checkRawOrder(courseId)
      const response = await this._getResponse<OrderCheck>(res)

      if (response.error) {
        return Result.ok<OrderCheck>({ status: "NOT_YET" })
      }

      return Result.ok<OrderCheck>(response.result)
    } catch (e) {
      return Result.ok<OrderCheck>({ status: "NOT_YET" })
    }
  }

  async getShareLink(slug: string) {
    try {
      const res = await this.getRawShareLink({
        long_url: `${process.env.HOME_URL}/learning/kelas/${slug}`,
        type: "direct",
        active: true,
      })

      if (res.ok) {
        const body = (await res.json()) as LinkResponse
        return Result.ok<string>(body.link.short_url)
      } else {
        return Result.fail<string>()
      }
    } catch (e) {
      return Result.fail<string>()
    }
  }
}
